

































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import WorkLog from '../../../store/entities/wm/worklog'
import ComboboxItem from '@/store/entities/combobox-item'
import CreateLogMember from './create-log-member.vue'
import serachmember from '@/store/entities/wm/searchworklogmember'
@Component({
  components: { CreateLogMember }
})
export default class EditWorkLog extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean
  editmember: boolean = false
  worklogModal: WorkLog = new WorkLog()
  logmembers: Array<any> = []
  oldlogmembers: Array<any> = []
  serachmember: serachmember = new serachmember()
  projectId: string = ''
  get roles() {
    return this.$store.state.user.roles
  }
  async handleClose() {
    this.logmembers = this.$store.state.worklog.memberlist
    this.oldlogmembers = this.$store.state.worklog.memberlist
  }
  async handleCancel() {
    this.logmembers = this.$store.state.worklog.oldmemberlist
  }
  async addmember() {
    if (!this.worklogModal.projectId) {
      this.$message({
        message: '请选择具体的项目',
        type: 'warning'
      })
      return
    }
    this.$store.commit('worklog/setmemberliststring', this.logmembers)
    this.$store.commit('worklog/setoldmemberliststring', this.oldlogmembers)
    this.serachmember.Id = this.projectId
    this.$store.commit('worklog/SearchWorkMember', this.serachmember)
    this.editmember = true
  }
  //删除标签
  removeMember(index) {
    this.logmembers.splice(index, 1)
  }
  //同意
  async Consent() {
    let reponse = await this.$store.dispatch({
      type: 'worklog/UpdateConsent',
      data: this.worklogModal.id
    })

    if (reponse.data.result > 0) {
      this.$Message.success('已同意')
      this.$emit('save-success')
      this.$emit('input', false)
    } else {
      this.$Message.warning('操作失败')
      return
    }
  }
  //拒绝
  async Refuse() {
    let reponse = await this.$store.dispatch({
      type: 'worklog/UpdateRefuse',
      data: this.worklogModal.id
    })
    if (reponse.data.result > 0) {
      this.$Message.success('已拒绝')
      this.$emit('save-success')
      this.$emit('input', false)
    } else {
      this.$Message.warning('操作失败')
      return
    }
  }
  save() {
    let mempeoplr = ''
    for (let i = 0; i < this.logmembers.length; i++) {
      mempeoplr += this.logmembers[i].userId + ',' // 获取从第一个字符开始的子字符串，即去掉开头的 "L"
    }
    this.worklogModal.invitelogid = mempeoplr
    ;(this.$refs.EditLogForm as any).validate(async (valid: boolean) => {
      var day = (new Date(this.worklogModal.endDate).getTime() - new Date(this.worklogModal.startDate).getTime()) / (1000 * 60 * 60 * 24)
      if (day < 0) {
        this.$Message.error(this.L('WM.ErrorDuration'))
        return
      }
      if (valid) {
        if (this.worklogModal.invitestatus == 4) {
          await this.$store.dispatch({
            type: 'worklog/UpdateConsent',
            data: this.worklogModal.id
          })
          await this.$store.dispatch({
            type: 'worklog/update',
            data: this.worklogModal
          })
          this.logmembers = []
          this.$store.commit('worklog/setmemberliststring', this.logmembers)
          this.$store.commit('worklog/setoldmemberliststring', this.logmembers)
          ;(this.$refs.EditLogForm as any).resetFields()
          this.$Message.success(this.L('EditionSuccess'))
          this.$emit('save-success')
          this.$emit('input', false)
        } else {
          await this.$store.dispatch({
            type: 'worklog/update',
            data: this.worklogModal
          })
          this.logmembers = []
          this.$store.commit('worklog/setmemberliststring', this.logmembers)
          this.$store.commit('worklog/setoldmemberliststring', this.logmembers)
          ;(this.$refs.EditLogForm as any).resetFields()
          this.$Message.success(this.L('EditionSuccess'))
          this.$emit('save-success')
          this.$emit('input', false)
        }
      }
    })
  }
  get projectIdList(): Array<ComboboxItem> {
    return this.$store.state.worklog.projectItem
  }
  projectIdChange(value) {
    let item = this.projectIdList.find((c) => c.value == value)
    this.worklogModal.projectName = item.displayText
    this.worklogModal.projectId = item.value
    //项目GUID
    this.projectId = item.value
  }
  startChange(value) {
    this.worklogModal.startDate = value
  }
  endChange(value) {
    this.worklogModal.endDate = value
  }
  clear() {
    this.$emit('input', false)
  }
  async deletelog() {
    await this.$store.dispatch('worklog/delete', { data: this.worklogModal })
    ;(this.$refs.EditLogForm as any).resetFields()
    this.$Message.success(this.L('DeletedSuccess'))
    this.$emit('save-success')
    this.$emit('input', false)
  }
  cancel() {
    this.logmembers = []
    ;(this.$refs.EditLogForm as any).resetFields()
    this.$emit('input', false)
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.$emit('input', value)
    } else {
      this.$store.dispatch({
        type: 'worklog/getSelectData'
      })
      this.worklogModal = Util.extend(true, {}, this.$store.state.worklog.editWorkLog)
      if (this.worklogModal.worktype == '0') {
        this.worklogModal.worktype = ''
      }
      this.projectId = this.worklogModal.projectId
    }
  }
  created() {
    // this.worklogModal = Util.extend(true, {}, this.$store.state.worklog.editWorkLog)
    // let item = this.projectIdList.find((c) => c.value == this.worklogModal.projectId)
    // if (item == null) {
    //   this.worklogModal.projectId = ''
    // }
  }
  workLogRule = {
    startDate: [{ required: true, message: this.L('PleaseSelect', undefined, this.L('WM.LogSETime')), trigger: 'change', pattern: /.+/ }],
    endDate: [{ required: true, message: this.L('PleaseSelect', undefined, this.L('WM.LogSETime')), trigger: 'change', pattern: /.+/ }],
    projectId: [{ required: true, message: this.L('PleaseSelect', undefined, this.L('WM.ProjectName')), trigger: 'change' }],
    worktype: [{ required: true, message: this.L('PleaseSelect', undefined, this.L('请选择日志类型')), trigger: 'change' }],
    txtBody: [{ required: true, message: this.L('PleaseInput', undefined, this.L('WM.LogContent')), trigger: 'blur' }]
  }
}
